import { motion } from "framer-motion"
import type { ComponentProps } from "react"
import { cn } from "@web/lib/utils"

function Card({ className, ...props }: ComponentProps<"div">) {
	return (
		<div
			data-slot="card"
			className={cn("flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm", className)}
			{...props}
		/>
	)
}

function CardHeader({ className, ...props }: ComponentProps<"div">) {
	return (
		<div
			data-slot="card-header"
			className={cn(
				"@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
				className,
			)}
			{...props}
		/>
	)
}

function CardTitle({ className, ...props }: ComponentProps<"div">) {
	return <div data-slot="card-title" className={cn("font-semibold leading-none", className)} {...props} />
}

function CardDescription({ className, ...props }: ComponentProps<"div">) {
	return <div data-slot="card-description" className={cn("text-muted-foreground text-sm", className)} {...props} />
}

function CardAction({ className, ...props }: ComponentProps<"div">) {
	return (
		<div
			data-slot="card-action"
			className={cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className)}
			{...props}
		/>
	)
}

function CardContent({ className, ...props }: ComponentProps<"div">) {
	return <div data-slot="card-content" className={cn("px-6", className)} {...props} />
}

function CardFooter({ className, ...props }: ComponentProps<"div">) {
	return <div data-slot="card-footer" className={cn("flex items-center px-6 [.border-t]:pt-6", className)} {...props} />
}

const MotionCard = motion.create(Card)
const MotionCardHeader = motion.create(CardHeader)
const MotionCardFooter = motion.create(CardFooter)
const MotionCardTitle = motion.create(CardTitle)
const MotionCardAction = motion.create(CardAction)
const MotionCardDescription = motion.create(CardDescription)
const MotionCardContent = motion.create(CardContent)

export {
	MotionCard as Card,
	MotionCardHeader as CardHeader,
	MotionCardFooter as CardFooter,
	MotionCardTitle as CardTitle,
	MotionCardAction as CardAction,
	MotionCardDescription as CardDescription,
	MotionCardContent as CardContent,
}
